import { search } from "algolia-instant-search";

const { connectHitsPerPage } = instantsearch.connectors;

if (!customElements.get("algolia-hits-per-page")) {
  class AlgoliaHitsPerPage extends HTMLElement {
    hitsPerPage = 12;

    connectedCallback() {
      this.selectElements();

      const customHitsPerPage = connectHitsPerPage(
        this.renderHitsPerPage.bind(this)
      );

      search.addWidgets([
        customHitsPerPage({
          container: this.content,
          items: [
            { label: "12 Items", value: 12, default: true },
            { label: "24 Items", value: 24 },
            { label: "48 Items", value: 48 },
          ],
        }),
      ]);
    }

    selectElements() {
      this.selectTemplate = this.querySelector("template#hits-per-page");
      this.content = this.querySelector("#content");
    }

    renderHitsPerPage(renderOptions, isFirstRender) {
      const { items, refine, widgetParams } = renderOptions;

      if (isFirstRender) {
        const selectClone = this.selectTemplate.content.cloneNode(true);
        widgetParams.container.appendChild(selectClone);
      }

      const select = widgetParams.container.querySelector("select");
      select.innerHTML = "";

      items.forEach((item) => {
        const optionElement = document.createElement("option");
        optionElement.value = item.value;
        optionElement.textContent = item.label;
        optionElement.selected = item.isRefined;
        select.appendChild(optionElement);
      });

      select.removeEventListener("change", this.onChange);
      this.onChange = (e) => {
        const value = e.target.value;
        this.hitsPerPage = value;
        refine(Number(value));
      };
      select.addEventListener("change", this.onChange);
    }
  }
  customElements.define("algolia-hits-per-page", AlgoliaHitsPerPage);
}
